<template>
  <div class="print">
    <div class="title">
      <dl class="dl1">
        <dt><img src="../../../assets/img/family.png" alt=""></dt>
        <dd>
          <p>中医方案</p>
          <p>客服电话：400-618-120 | 服务时间：10:00-22:00</p>
        </dd>
      </dl>
      <dl class="dl2">
        <dt><img src="../../../assets/img/code1.png" alt=""></dt>
        <dd>
          <p>家庭中医馆APP</p>
        </dd>
      </dl>
      <dl class="dl3">
        <dt><img src="../../../assets/img/code2.png" alt=""></dt>
        <dd>
          <p>家庭中医馆公众号</p>
        </dd>
      </dl>

    </div>
    <div class="print_order_info">
      <div class="info_tag">
        订单信息
      </div>
      <div class="info_text">
        <div class="info_address">
          <div class="address1">
            <div>收货人：</div>
            {{ JSON.stringify(detail) != "{}" ? detail.addressee : "" }}
          </div>
          <div class="address">
            <div>手机号：</div>
            {{ JSON.stringify(detail) != "{}" ? detail.phone : "" }}
          </div>
          <div class="address">
            <div>订单地址：</div>
            {{ JSON.stringify(detail) != "{}" ? detail.address : "" }}
          </div>
        </div>
        <div class="info_order">

          <div class="info_address">
            <div class="address1">
              <div>订单号：</div>
              {{
                JSON.stringify(detail) != "{}" ? detail.out_trade_no : ""
              }}
            </div>
            <div class="address">
              <div>下单时间：</div>
              {{
                JSON.stringify(detail) != "{}"
                    ? formatDate(detail.created_time)
                    : ""
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="print_prescription_info">
      <div class="info_tag">
        处方信息
      </div>
      <div class="prescription_text">
        <div class="prescription_info1">
          <div class="prescription_li">
            <div>
              姓名：
            </div>
            {{ JSON.stringify(detail) != "{}" ? detail.patient_name : "" }}
          </div>
          <div class="prescription_li">
            <div>
              性别：
            </div>
            {{
              JSON.stringify(detail) != "{}"
                  ? detail.patient_sex == 1
                  ? "男"
                  : "女"
                  : ""
            }}
          </div>
          <div class="prescription_li">
            <div>
              年龄：
            </div>
            {{ JSON.stringify(detail) != "{}" ? detail.patient_age : "" }}岁
          </div>
        </div>
        <div class="prescription_zd">
          <div>
            诊断：
          </div>
          <span
          >{{
              JSON.stringify(detail) != "{}" ? detail.diseases : ""
            }}
                <span v-if="JSON.stringify(detail) != '{}' && detail.symptons"
                >·</span
                >
                {{
              JSON.stringify(detail) != "{}" ? detail.symptons : ""
            }}</span
          >
        </div>
        <div class="pharmacy_info">
          <div class="pharmacy_name">
            {{
              JSON.stringify(detail) != "{}"
                  ? detail.provider_info.name
                  : ""
            }}-{{JSON.stringify(detail) != '{}'? detail.provider_info.type == 1?'免煎颗粒': '中药饮片': '中药饮片'}}(共{{JSON.stringify(detail) != '{}'? detail.provider_info.total_count :'' }}味药) <span style="color: #ac4b38">帖数:{{
              JSON.stringify(detail) != "{}" && detail.provider_info
                  ? detail.provider_info.total_count
                  : ""
            }}帖</span>
          </div>
          <div class="pharmacy_drug">
            <p>中药明细：</p>
            <div class="drug_ul">
              <div class="drug_li" v-for="(item,index) in JSON.stringify(detail) != '{}' && detail.provider_info? JSON.parse(detail.provider_info.content): [] " :key="index">
                <p>{{item.name}}{{item.count}}{{item.unit}}</p>
                <p>
                 <span class="span11"> {{(item.usage && item.usage != ""
                     ? "[" + item.usage + "]"
                     : "")}}</span>
                 <span class="span22"> {{(item.signature && item.signature != ""
                     ? "[" + item.signature + "]"
                     : "")}}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="usage">
            <div class="usage1">
              <div>
                <span style="color: #AC4B38">*</span>{{
                  JSON.stringify(detail) != "{}" && detail.provider_info
                      ? detail.provider_info.usage == 1
                      ? "内服；"
                      : "外用；"
                      : ""
                }}
              </div>
              <span
                  v-if="detail.provider_info && detail.provider_info.usage == 1"
              >{{
                  JSON.stringify(detail) != "{}" && detail.provider_info
                      ? "每日" +
                      detail.provider_info.one_day_count +
                      "帖，一帖分" +
                      detail.provider_info.once +
                      "次服用"
                      : ""
                }}</span
              >
              <span
                  v-if="detail.provider_info && detail.provider_info.usage == 2"
              >{{
                  JSON.stringify(detail) != "{}" && detail.provider_info
                      ? "每日" +
                      detail.provider_info.one_day_count +
                      "帖，一帖分" +
                      detail.provider_info.once +
                      "次使用"
                      : ""
                }}</span
              >
            </div>
            <div class="usage2">
              <div>
                <span style="color: #AC4B38">*</span>医嘱：
              </div>
              {{
                JSON.stringify(detail) != "{}" && detail.provider_info
                    ? detail.provider_info.advice
                    : ""
              }}
            </div>
            <div class="doctor">
              <span>医生：{{
                  JSON.stringify(detail) != "{}" && detail.provider_info
                      ? detail.doctor_name
                      : ""
                }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['detail'],
  methods:{
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
  }
}
</script>

<style>
@import "dayin.css";
</style>
<style lang="scss" scoped>
@media print {
  @page {
    size: A4;
    margin: 0;
  }

  body {
    margin: 0;
    padding: 0;
  }
}
</style>